// extracted by mini-css-extract-plugin
module.exports =  {"adminZoomSettings":"Qbl1y4_Q","content":"rzJj7pKi","alert":"T7vlUiLg","articleLink":"SSi1d5WA","installButtons":"OGecW931"};